var _defs, _path, _polygon, _path2, _polygon2, _line, _path3, _path4, _path5, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435.51 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c1d5d7;}.cls-2{fill:#781d0f;}.cls-3{fill:#9b2115;}.cls-4{fill:#6b170e;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-5{stroke:#4c100a;stroke-width:3px;}.cls-6{stroke:#c5c1b1;stroke-width:12px;}.cls-7{fill:#4c100a;}.cls-8{fill:#c5e8e7;}.cls-9{fill:#c5c1b1;}.cls-10{fill:#defcf9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-54,428",
    transform: "translate(-67.53 -41)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "435.51 357.87 0 357.87 75.69 220.11 359.81 220.11 435.51 357.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.53,398.87l10.81,69.28A51.85,51.85,0,0,0,129.57,512H441a51.83,51.83,0,0,0,51.22-43.85L503,398.87Z",
    transform: "translate(-67.53 -41)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "407.74 83.11 29.1 83.11 76.36 220.88 360.48 220.88 407.74 83.11"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 76.36,
    y1: 220.87,
    x2: 360.48,
    y2: 220.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.63,124.11l10-51.15a39.55,39.55,0,0,1,38.82-32H425.62a39.55,39.55,0,0,1,38.69,31.36l11,51.75Z",
    transform: "translate(-67.53 -41)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.11,327.49s-30.72-79.79,33.05-91.31c82.9-15,77.84,71.82,67.53,92.21",
    transform: "translate(-67.53 -41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.27,335a76,76,0,0,1,14.08-8.92,103.83,103.83,0,0,1,15.57-6.23A107.47,107.47,0,0,1,285.17,315c1.4,0,2.81,0,4.22.12s2.81.14,4.21.26c2.8.31,5.6.56,8.37,1.07s5.52,1.05,8.26,1.65c1.37.32,2.71.72,4.07,1.09s2.7.74,4,1.22A116.56,116.56,0,0,1,348.24,335a198.73,198.73,0,0,0-31-10.87c-1.31-.37-2.64-.63-4-.9s-2.65-.61-4-.85c-2.68-.43-5.33-1-8-1.27A123.16,123.16,0,0,0,285.12,320,132.37,132.37,0,0,0,253,323.58a137.57,137.57,0,0,0-15.63,4.72A114.4,114.4,0,0,0,222.27,335Z",
    transform: "translate(-67.53 -41)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "205.53 194.35 187.68 168.86 218.96 126.04 247.78 166.39 232.88 194.35 205.53 194.35"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "205.53 194.35 200.83 187.64 206.61 189.41 209.91 186.12 213.2 189.41 216.51 186.12 219.79 189.41 223.82 186.12 226.37 189.41 229.96 186.12 231.31 189.41 236.84 186.91 232.88 194.35 205.53 194.35"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "217.48 148.18 227.99 142.77 234.14 127.1 239.44 143.11 249.86 149.16 239.35 154.57 234.14 170.62 227.9 154.22 217.48 148.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.e23c4a61.svg";
export { ForwardRef as ReactComponent };